export enum ProductStructure {
  SingleProduct = 'Product',
  BundleProduct = 'ProductBundle',
}
